export enum FOOD_CATEGORY {
  F01 = 'F01',
  F02 = 'F02',
  F03 = 'F03',
  F04 = 'F04',
  F05 = 'F05',
  F06 = 'F06',
  F07 = 'F07',
  F08 = 'F08',
  F09 = 'F09',
  F10 = 'F10',
  F11 = 'F11',
  F12 = 'F12',
  F13 = 'F13',
  F14 = 'F14',
  F15 = 'F15',
  F16 = 'F16',
}
export const CONST_FOOD_CATEGORY = Object.values(FOOD_CATEGORY);
